import React, { useEffect } from 'react';
import { getSsoUrl } from '../containers/Login/LoginSlice/actionCreators';
import { logoutUser } from '../containers/Sidebar/actionCreators';
import { useAppDispatch } from '../hooks';

function LoginSkolonPage() {
  const dispatch = useAppDispatch();

  const loginSkolon = async () => {
    dispatch(getSsoUrl(null, 'Skolon'));
  };

  useEffect(() => {
    dispatch(logoutUser());
    loginSkolon();
  }, []);

  return <div></div>;
}

export default LoginSkolonPage;
